export default __webpack_public_path__ + "static/img6-e562863d4c7335e61350224bd855b70e.png";